/** What the shell needs from whichever sign-in adapter is active (D-23, D-24). */
export interface AuthAdapter {
  readonly mode: "oidc" | "mock";
  /** Current bearer token, or null when signed out. */
  getToken(): Promise<string | null>;
  /** Starts the sign-in journey (redirects to the provider, or steps the mock journey). */
  signIn(): Promise<void>;
  /** Completes the provider's redirect back (no-op in mock mode). */
  completeSignIn(): Promise<void>;
  /** Ends the session here and at the provider (ADM-07). */
  signOut(): Promise<void>;
  /** Fires when the session changes (signed in, renewed, signed out, expired). */
  subscribe(listener: () => void): () => void;
}

export interface AuthConfigLike {
  issuer: string;
  clientId: string;
  tenantName: string;
  demo: boolean;
}

/** Sessions end after 30 minutes idle (ADM-07). */
export const IDLE_LIMIT_MS = 30 * 60 * 1000;
